import React from 'react';
import { Grid, InputAdornment, TextField } from '@material-ui/core';
import { CommonButton } from '../Buttons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { StyledTableHeader } from './style';
import { StyledSearchAdornment } from '../../Header/style';

const TableHeader = ({ btnAction, btnLabel, setSearchString, placeholder }) => {
  return (
    <StyledTableHeader container spacing={btnAction ? 2 : 0}>
      <Grid item xs={btnAction ? 10 : 12}>
        <TextField
          fullWidth
          placeholder={placeholder || 'Pesquisar'}
          onChange={(e) => setSearchString(e.target.value)}
          InputProps={{
            endAdornment: (
              <InputAdornment position="start">
                <StyledSearchAdornment icon={faSearch} />
              </InputAdornment>
            ),
          }}
          variant="outlined"
        />
      </Grid>
      {btnAction && (
        <Grid item xs={2}>
          <CommonButton action={btnAction} label={btnLabel || 'Adicionar'} />
        </Grid>
      )}
    </StyledTableHeader>
  );
};

export default TableHeader;
